import { useState } from 'react';

const MainMenuCard = ({ title, image, onClick }) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  return (
    <div
      className="group relative w-full overflow-hidden rounded-2xl bg-white shadow-sm ring-1 ring-black/5 transition-all duration-200 cursor-pointer aspect-[4/5] md:aspect-[4/4.8]"
      onClick={onClick}
    >
      <div className="absolute inset-0 bg-black/35 group-hover:bg-black/25 transition-all duration-200 z-10" />

      {!imageLoaded && <div className="absolute inset-0 bg-gray-200 animate-pulse z-0" />}

      <img
        src={image}
        alt={title}
        className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-500 ${imageLoaded ? 'opacity-100' : 'opacity-0'}`}
        onLoad={() => setImageLoaded(true)}
        loading="lazy"
        decoding="async"
        sizes="(min-width: 1024px) 260px, (min-width: 768px) 45vw, 90vw"
      />

      <div className="absolute inset-0 flex items-center justify-center z-20 px-3 text-center">
        <h2 className="text-white text-xl sm:text-2xl font-semibold tracking-tight drop-shadow-md leading-tight">
          {title}
        </h2>
      </div>
    </div>
  );
};

export default MainMenuCard;
